import { render, staticRenderFns } from "./Home.data-manager-alternate-seat.vue?vue&type=template&id=337d4b8e&scoped=true&"
import script from "./Home.data-manager-alternate-seat.vue?vue&type=script&lang=js&"
export * from "./Home.data-manager-alternate-seat.vue?vue&type=script&lang=js&"
import style0 from "./Home.data-manager-alternate-seat.vue?vue&type=style&index=0&id=337d4b8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337d4b8e",
  null
  
)

export default component.exports